import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '@shared/models/request-state';
import { ApiCacheService } from '@shared/services/api-cache.service';
import { LoadRequest } from './models/load.request';
import { LoadResponse } from './models/load.response';

@Injectable({
  providedIn: 'root',
})
export class LoadService {
  private readonly _url = `${environment.apiUrl}load`;

  constructor(private cacheService: ApiCacheService) {}

  getLoad(
    loadRequest: LoadRequest,
    isRefresh: boolean
  ): Observable<RequestState<LoadResponse>> {
    const { flightNumber, date, depStation } = loadRequest;
    const cacheId = this.getCacheId(loadRequest);
    const url = `${this._url}/${flightNumber}/${date}/${depStation}`;

    if (isRefresh) {
      return this.cacheService.forceRefreshGet<LoadResponse>(cacheId, url);
    } else {
      return this.cacheService.request<LoadResponse>(cacheId, url);
    }
  }

  private getCacheId(loadRequest: LoadRequest): string {
    const { flightNumber, date, depStation } = loadRequest;
    return `load-${flightNumber}/${date}/${depStation}`;
  }
}
